<template>

  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>Vehicle</strong> <small>Info</small>
          <div class="pull-right">
            <button id="btnReturnToInv" class="btn btn-warning" @click="$router.push('Inventory')"><i title="Back" class="fa fa-arrow-left fa-lg text-white"></i> <strong class="text-white">Return to Inventory</strong></button>
            <button id="btnSave" class="btn btn-info" v-if="vehicle" @click="saveVehicle"><i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong></button>
          </div>
        </div>
        <b-row>
          <b-col lg="6">
            <slot v-if="vehicle && vehicle.VehicleDescription && vehicle.VehicleDescription.length">
              <b-btn @click="showHeader = !showHeader" aria-controls="collapse1" variant="primary">{{vehicle.VehicleDescription}}</b-btn>
            </slot>
            <b-collapse v-model="showHeader" id="collapse1" class="mt-2">
              <b-card container fluid title="Select Vehicle">
                <b-row class="my-1">
                  <b-col lg="3">
                    <label>VIN</label>
                  </b-col>
                  <b-col lg="6">
                    <b-form-group>
                      <b-input-group>
                        <b-form-input id="inpInitVIN" type="text" v-model="selectvehicle.VIN" :maxlength="17"></b-form-input>
                        <b-input-group-append>
                          <b-btn id="btnSearch" @click="findByVIN">Search</b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row class="my-1">
                  <b-col lg="3">
                    <label>Type</label>
                  </b-col>
                  <b-col lg="6">
                    <b-form-select id="selType" v-model="selectvehicle.IsNew" :options="typesList" @change="onTypeChanged($event)" />
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col lg="3">
                    <label>Year</label>
                  </b-col>
                  <b-col lg="6">
                    <b-form-select id="selyear" v-model="selectvehicle.Year" :options="yearsList" @change="onYearChanged($event)" />
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col lg="3">
                    <label>Make</label>
                  </b-col>
                  <b-col lg="6">
                    <b-form-select id="selMake" v-model="selectvehicle.MakeId" :options="makesList" @change="onMakeChanged($event)" />
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col lg="3">
                    <label>Model</label>
                  </b-col>
                  <b-col lg="6">
                    <b-form-select id="selModel" v-model="selectvehicle.ModelId" :options="modelsList" @change="onModelChanged($event)" />
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col lg="3">
                    <label>Trim</label>
                  </b-col>
                  <b-col lg="6">
                    <b-form-select id="selTrim" v-model="selectvehicle.NewUsedId" :options="trimsList" @change="onTrimChanged($event)" />
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col v-if="multipleVehicleMatch.length">
                    <b-card>
                      <div slot="header">
                        <b-alert variant="warning" class="mb-0" show><strong>Multiple vehicles match for this VIN, select a vehicle to proceed.</strong></b-alert>
                      </div>
                      <table aria-busy="false" class="table b-table table-bordered table-sm">
                        <tbody>
                          <tr v-for="(vm, i) in multipleVehicleMatch">
                            <td style="width:85px;">
                              <button class="btn btn-primary text-white" @click="selectMultiVehicle(vm)">
                                <i class="fa fa-car" title="Select this vehicle"></i> Select
                              </button>
                            </td>
                            <td>
                              {{vm.description}}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-card>
                  </b-col>
                </b-row>
              </b-card>
            </b-collapse>
          </b-col>
        </b-row>
        <b-row v-if="vehicle">
          <b-col lg="6">
            <b-card container fluid title="Description" v-if="vehicle">
              <b-row class="my-1">
                <b-col lg="3">
                  <label>VIN</label>
                </b-col>
                <b-col lg="6">
                  <b-form-input id="inpRequiredVIN" type="text" v-model="vehicle.VIN" :maxlength="17" v-validate="{required: true}"
                                v-bind:class="{'is-invalid': validateErrors.has('VIN') }" name="VIN"></b-form-input>
                  <em class="error invalid-feedback">{{ validateErrors.first('VIN') }}</em>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="3">
                  <label>Stock #</label>
                </b-col>
                <b-col lg="6">
                  <b-form-input id="inpStockNum" type="text" v-model="vehicle.StockNumber" v-validate="{required: true}"
                                v-bind:class="{'is-invalid': validateErrors.has('Stock') }" name="Stock"
                                :maxlength="20"></b-form-input>
                  <em class="error invalid-feedback">{{ validateErrors.first('Stock') }}</em>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="3">
                  <label>Exterior Color</label>
                </b-col>
                <b-col lg="6">
                  <b-form-input id="inpExterColor" type="text" v-model="vehicle.ExteriorColor" :maxlength="50"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="3">
                  <label>Interior Color</label>
                </b-col>
                <b-col lg="6">
                  <b-form-input id="inpInterColor" type="text" v-model="vehicle.InteriorColor" :maxlength="50"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="3">
                  <label>Options/Packages</label>
                </b-col>
                <b-col lg="6">
                  <b-form-textarea id="inpOptionsPackages" type="text" v-model="vehicle.Options" :rows="3" :maxlength="120"></b-form-textarea>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="3">
                  <label>Lot Age (days)</label>
                </b-col>
                <b-col lg="3">
                  <b-form-input id="inpLotAge" type="text" v-model="vehicle.LotAge" name="Lotage" :maxlength="10" v-validate="{numeric: true}"
                                v-bind:class="{'is-invalid': validateErrors.has('Lotage') }"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="3" class="mt-2">
                  Mileage
                </b-col>
                <b-col lg="3">
                  <b-form-input id="inpMileage" type="text" v-model="vehicle.DemoMiles" name="Mileage" v-validate="{numeric: true}"
                                v-bind:class="{'is-invalid': validateErrors.has('Mileage') }"></b-form-input>
                </b-col>
                <b-col lg="4" class="mt-2" v-if="!vehicle.IsNew">
                  <b-form-checkbox v-model="vehicle.CertifiedPreOwned">Certified Pre-owned</b-form-checkbox>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col><h4>MSRP</h4></b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="2">
                  Base Value
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" class="money" v-model="vehicle.BaseValueMSRP" name="BaseValueMSRP" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('BaseValueMSRP') }"></b-form-input>
                </b-col>
                <b-col lg="2">
                  Total
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" class="money" v-model="vehicle.TotalMSRP" name="TotalMSRP" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('TotalMSRP') }"></b-form-input>
                </b-col>
                <b-col lg="2">
                  Discounts
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" class="money" v-model="vehicle.MSRPDiscounts" name="MSRPDiscounts" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('MSRPDiscounts') }"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col><h4>Cost</h4></b-col>
              </b-row>
              <b-row class="my-1">
                <b-col lg="2">
                  Before Adds
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" class="money" v-model="vehicle.DealerCostBeforeAdds" name="DealerCostBeforeAdds" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('DealerCostBeforeAdds') }"></b-form-input>
                </b-col>
                <b-col lg="2">
                  Added Equipments
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" class="money" v-model="vehicle.OptionsAndTreatmentCost" name="OptionsAndTreatmentCost" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('OptionsAndTreatmentCost') }"></b-form-input>
                </b-col>
                <b-col lg="2">
                  Total Dealer Cost
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" class="money" v-model="vehicle.TotalDealerCost" name="TotalDealerCost" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('TotalDealerCost') }"></b-form-input>
                </b-col>
              </b-row>

              <b-row class="my-1">
                <b-col><h4>Prices</h4></b-col>
              </b-row>

              <b-row class="my-1">
                <b-col lg="2">
                  Sticker
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" class="money" v-model="vehicle.Price" name="Price" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('Price') }"></b-form-input>
                </b-col>
                <b-col lg="2">
                  Preferred
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" class="money" v-model="vehicle.PreferredPrice" name="PreferredPrice" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('PreferredPrice') }"></b-form-input>
                </b-col>
                <b-col lg="2">
                  GMS
                </b-col>
                <b-col lg="2">
                  <b-form-input type="text" class="money" v-model="vehicle.GMSPrice" name="GMSPrice" v-validate="{decimal: 2}"
                                v-bind:class="{'is-invalid': validateErrors.has('GMSPrice') }"></b-form-input>
                </b-col>
              </b-row>
              <slot v-if="vehicle.AddsDeducts && vehicle.AddsDeducts.NewCar && vehicle.AddsDeducts.NewCar.VehicleDeductions">
                <b-row class="my-1">
                  <b-col><h4>Deductions</h4></b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <slot v-for="(item, idx) in vehicle.AddsDeducts.NewCar.VehicleDeductions">
                      <b-form-checkbox :id="`${(item.Name).replace(/ /g, '')}_${idx}`" v-model="item.Added">{{item.Name}}</b-form-checkbox>
                    </slot>
                  </b-col>
                </b-row>
              </slot>
            </b-card>
          </b-col>

        </b-row>

      </b-card>
    </div>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import { isUndefined, isNullOrUndefined, isNull } from 'util'

export default {
  components: {
    loading
  },
  created () {
    axios.all([
      axios.get('/api/quotepolicy/getyears?isnew=1&year=0&make=0&model=0'),
      axios.get('/api/quotepolicy/getyears?isnew=0&year=0&make=0&model=0')
    ])
      .then(axios.spread((newYearsRes, usedYearsRes) => {
        this.list_year_new = newYearsRes.data.filter(x => (x.id > 0)).map(x => { return { text: x.name, value: x.id } })
        this.list_year_used = usedYearsRes.data.filter(x => (x.id > 0)).map(x => { return { text: x.name, value: x.id } })
        this.boolLoading = false
      }))
      .catch(error => {
        if (error.response.status === 403) { this.$router.push('/login') }

        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      showHeader: true,
      boolLoading: false,
      txtLoading: 'Loading...',
      selectvehicle: {
        IsNew: null, Year: null, VIN: null
      },
      vehicle: null,
      typesList: [{ text: 'New', value: 1 }, { text: 'Used', value: 0 }],
      list_year_new: [],
      list_year_used: [],
      yearsList: [],
      makesList: [],
      modelsList: [],
      trimsList: [],
      deductions: [{
        key: 'Name', label: 'Deductions', thClass: 'h4 card-title table-borderless'
      }],
      multipleVehicleMatch: []
    }
  },
  methods: {
    onTypeChanged (arg) {
      if (arg === 1) { this.yearsList = this.list_year_new } else { this.yearsList = this.list_year_used }

      this.vehicle = null
      this.selectvehicle.Year = null
      this.selectvehicle.MakeId = null
      this.selectvehicle.ModelId = null
      this.selectvehicle.NewUsedId = null
      self.multipleVehicleMatch = []
    },
    onYearChanged (arg) {
      var self = this
      if (self.selectvehicle.IsNew < 0) {
        alert('Select a type')
        return
      }

      self.boolLoading = true
      self.vehicle = null
      self.selectvehicle.MakeId = null
      self.selectvehicle.ModelId = null
      self.selectvehicle.NewUsedId = null
      self.multipleVehicleMatch = []
      axios.get('/api/quotepolicy/getmakes?isnew=' + self.selectvehicle.IsNew + '&year=' + arg + '&make=0&model=0')
        .then(response => {
          self.makesList = response.data.filter(x => (x.id > 0)).map(x => { return { text: x.name, value: x.id } })
          self.boolLoading = false
        })
        .catch(error => {
          self.SetErrorMsg(error, 'getting')
        })
    },
    onMakeChanged (arg) {
      var self = this
      if (self.selectvehicle.IsNew < 0 || isNullOrUndefined(self.selectvehicle.Year)) {
        alert('Select a type and year')
        return
      }

      self.boolLoading = true
      self.vehicle = null
      self.selectvehicle.ModelId = null
      self.selectvehicle.NewUsedId = null
      self.multipleVehicleMatch = []
      axios.get('/api/quotepolicy/getmodels?isnew=' + self.selectvehicle.IsNew + '&year=' + self.selectvehicle.Year + '&make=' + arg + '&model=0')
        .then(response => {
          self.modelsList = response.data.filter(x => (x.id > 0)).map(x => { return { text: x.name, value: x.id } })
          self.boolLoading = false
        })
        .catch(error => {
          self.SetErrorMsg(error, 'getting')
        })
    },
    onModelChanged (arg) {
      var self = this
      self.boolLoading = true
      self.vehicle = null
      self.selectvehicle.NewUsedId = null
      self.multipleVehicleMatch = []
      axios.get('/api/quotepolicy/gettrims?isnew=' + self.selectvehicle.IsNew + '&year=' + self.selectvehicle.Year + '&make=' + self.selectvehicle.MakeId + '&model=' + arg)
        .then(response => {
          self.trimsList = response.data.filter(x => (x.id > 0)).map(x => { return { text: x.name, value: x.id } })
          self.boolLoading = false
        })
        .catch(error => {
          self.SetErrorMsg(error, 'getting')
        })
    },
    onTrimChanged (arg) {
      var self = this
      self.boolLoading = true
      self.vehicle = null
      self.multipleVehicleMatch = []
      axios.post('/api/inventory/findvehicle?trimid=' + arg)
        .then(response => {
          self.vehicle = response.data
          self.showHeader = !(self.vehicle.VehicleDescription.length > 0)
          self.boolLoading = false
        })
        .catch(error => {
          self.SetErrorMsg(error, 'getting')
        })
    },
    findByVIN () {
      let self = this
      if (self.selectvehicle.VIN == isNull || self.selectvehicle.VIN.length <= 0) { return }

      self.boolLoading = true
      self.vehicle = null
      self.multipleVehicleMatch = []
      axios.post('/api/inventory/findvehiclebyvin?vin=' + self.selectvehicle.VIN)
        .then(response => {
          self.vehicle = response.data.vehicle
          if (self.vehicle) {
            self.vehicle.VIN = self.selectvehicle.VIN
            self.showHeader = !(self.vehicle.VehicleDescription.length > 0)

            self.yearsList = self.vehicle.IsNew === 1 ? this.list_year_new : this.list_year_used
            self.makesList = [{ text: self.vehicle.Make, value: self.vehicle.MakeID }]
            self.modelsList = [{ text: self.vehicle.Model, value: self.vehicle.ModelID }]
            self.trimsList = [{ text: self.vehicle.Trim, value: self.vehicle.NewUsedID }]

            self.selectvehicle.IsNew = self.vehicle.IsNew
            self.selectvehicle.Year = self.vehicle.Year
            self.selectvehicle.MakeId = self.vehicle.MakeID
            self.selectvehicle.ModelId = self.vehicle.ModelID
            self.selectvehicle.NewUsedId = self.vehicle.NewUsedID
          } else {
            self.multipleVehicleMatch = response.data.match.map(x => { x['VIN'] = self.selectvehicle.VIN; return x })
          }
          self.boolLoading = false
        })
        .catch(error => {
          self.SetErrorMsg(error, 'getting')
        })
    },
    selectMultiVehicle (v) {
      var self = this

      if (v.id == isNull || v.id.length <= 0) { return }

      self.boolLoading = true
      self.vehicle = null
      axios.post('/api/inventory/findvehicle?trimid=' + v.id)
        .then(response => {
          self.vehicle = response.data
          if (self.vehicle) {
            self.vehicle.VIN = v.VIN
            self.showHeader = !(self.vehicle.VehicleDescription.length > 0)

            self.yearsList = self.vehicle.IsNew === 1 ? this.list_year_new : this.list_year_used
            self.makesList = [{ text: self.vehicle.Make, value: self.vehicle.MakeID }]
            self.modelsList = [{ text: self.vehicle.Model, value: self.vehicle.ModelID }]
            self.trimsList = [{ text: self.vehicle.Trim, value: self.vehicle.NewUsedID }]

            self.selectvehicle.IsNew = self.vehicle.IsNew
            self.selectvehicle.Year = self.vehicle.Year
            self.selectvehicle.MakeId = self.vehicle.MakeID
            self.selectvehicle.ModelId = self.vehicle.ModelID
            self.selectvehicle.NewUsedId = self.vehicle.NewUsedID
          }
          self.boolLoading = false
        })
        .catch(error => {
          self.SetErrorMsg(error, 'getting')
        })
    },
    saveVehicle () {
      var self = this
      if (!self.vehicle) {
        self.errMsg = 'Data missing.'
        self.showDismissibleAlert = true
        return
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          self.boolLoading = true
          axios.post('/api/inventory/createvehicle', self.vehicle)
            .then(response => {
              self.errMsg = 'Vehicle Saved'
              self.dismissibleType = 'success'
              self.showDismissibleAlert = true
              self.boolLoading = false
            })
            .catch(error => {
              self.SetErrorMsg(error, 'saving')
            })
        }
      })
    },
    SetErrorMsg (error, action) {
      var self = this

      if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { self.$router.push('/login') }

      self.boolLoading = false

      self.errMsg = 'There was an error ' + action + ' your changes : '
      if (error !== undefined && error.response !== undefined && error.response.statusText !== undefined) {
        self.errMsg = self.errMsg + error.response.statusText
      } else {
        self.errMsg = self.errMsg + error
      }

      self.dismissibleType = 'danger'
      self.showDismissibleAlert = true

      if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { self.errMsg = error.response.statusText.replace('403.1', '') }
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }
}
</script>
<style>
  .table > tbody > tr > td {
    vertical-align: middle;
  }

  .money {
    text-align: right;
  }

  .input-group-text {
    background-color: transparent;
    border: none;
  }

  .table-borderless td,
  .table-borderless th {
    border: 0;
  }

  .table thead th {
    border-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/AddInventory.vue